import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { attendanceReportToExcel, convertToDateWithoutYear, generateDropdownOptions } from '../../../utility/genricFunction'
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import { ROUTES_PATH } from '../../../utility/constants'
import { ErrorMessage, Form, Formik } from 'formik'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import './attendanceReport.scss'
import Button from '../../../components/button/Button'
import { getAttendanceReport, getBatchFromBranch } from '../../../store/builders/reports/reports.builder'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'


function AttendanceReport() {
    const dispatch = useDispatch()

    const attendanceData = useSelector((store) => store?.reports?.attendanceReportData)
    const {loading , pageDropDownLoading} = useSelector((store) => store?.reports)


    const batches = useSelector((store) => store.reports.batches)
    const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches])

    const branches = useSelector((state) => state?.branch?.branchTableData)
    const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

    const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
    const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

    const [branch, setBranch] = useState("")
    const [batch, setBatch] = useState("")
    const [isTableOpen, setIsTableOpen] = useState(false)

    const [dates, setDates] = useState([])
    const [students, setStudents] = useState([])

    const [initialValues] = useState({
        branch: userRole == "branch" ? branchId : '',
        batch: ''
    })

    useEffect(() => {
        // dispatch(getBranch('active'))

        if (userRole == "branch") {
            dispatch(getBatchFromBranch(branchId))
        }

    }, [])


    useEffect(() => {
        // This should ideally be set with actual data from the API
        const { studentAttendanceData, batchData } = attendanceData;
        setStudents(studentAttendanceData);

        const startDate = new Date(batchData?.start_date);
        const endDate = new Date(batchData?.end_date);
        const dateList = [];

        for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
            dateList.push(new Date(d));
        }

        setDates(dateList);
    }, [attendanceData])

    const validationSchema = Yup.object().shape({
        branch: Yup.string()
            .required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
        batch: Yup.string()
            .required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    })

    function handleFormSubmit(values) {
        setBranch(values.branch)
        setBatch(values.batch)
        setIsTableOpen(true)

        const data = {
            branch: values.branch,
            batch: values.batch
        }

        dispatch(getAttendanceReport(data))
    }

    const handleBranchChange = (value, setFieldValue) => {
        setFieldValue("branch", value)
        dispatch(getBatchFromBranch(value))
    }

    const breadCrumbsArr = [
        {
            title: 'Attendance details',
            link: null,
        },
        {
            title: 'Dashboard',
            link: ROUTES_PATH.DASHBOARD,
        },
        {
            title: 'Attendance report ',
            link: ROUTES_PATH.ATTENDANCE_REPORT,
        },
    ]

    const dateBody = (rowData, column) => {
        const attendanceRecord = rowData.student_attendance.find(record => record.date === column.field);
        return (
            <div className='flex align-items-center justify-center gap-2'>
                <span>{attendanceRecord ? attendanceRecord?.attendance : '-'}</span>
            </div>
        )
    }


    const printRef = useRef()

    const handleDownloadPfd = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <>
        {loading && <Loader loading={loading} />}
        {<Loader loading={loading} /> && <div className='attendanceReport-wrapper'>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    handleFormSubmit(values)
                }}
                enableReinitialize
            >
                {({ values, handleChange, handleSubmit, setFieldValue }) => (
                    <Form>
                        <div className='attendanceReport-header'>
                            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                        </div>

                        <div className='attendanceReport'>
                            <div className='attendanceReport-input-fields'>

                                <div className='attendanceReport-input'>
                                    <label htmlFor=''>
                                        Branch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={branchOption}
                                        selectedValue={values.branch}
                                        className={'attendanceReport-dropdown'}
                                        onChange={(e) => handleBranchChange(e.target.value, setFieldValue)}
                                        name={'branch'}
                                        placeholder={'Select Branch'}
                                        disabled={userRole == "branch"}
                                    />
                                    <ErrorMessage name='branch' component='div' className='error-msg' />
                                </div>

                                <div className='attendanceReport-input'>
                                    <label htmlFor=''>
                                        Batch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={batchOptions}
                                        selectedValue={values.batch}
                                        className={'attendanceReport-dropdown'}
                                        onChange={handleChange}
                                        name={'batch'}
                                        placeholder={'Select Batch'}
                                    />
                                    <ErrorMessage name='batch' component='div' className='error-msg' />
                                </div>

                                <div className='report-submit-div'>
                                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </Form>
                )}
            </Formik>

            {isTableOpen && <div className='attendanceReport-table'>
                <div className='export-option-wrapper'>
                    <div className='pdf-excel-export'>
                        <Button
                            text={'Export'}
                            type={'button'}
                            onClick={() =>
                                attendanceReportToExcel(attendanceData, dates, 'Attendance Report', 'attendance.xlsx')
                            }
                            disabled={attendanceData?.studentAttendanceData?.length > 0 ? false : true}
                        >
                            <SimCardDownloadIcon />
                        </Button>

                        <Button
                            text={'Export'}
                            type={'button'}
                            onClick={handleDownloadPfd}
                            disabled={attendanceData?.studentAttendanceData?.length > 0 ? false : true}
                        ><PrintIcon />
                        </Button>
                    </div>
                </div>

                <div ref={printRef} className='printable-component'>

                    <DataTable value={students}>
                        <Column field="no" header="no" style={{ minWidth: '4rem', textAlign: "center" }} />
                        <Column field="student_code" header="Code" style={{ minWidth: '8rem', textAlign: "center" }} />
                        <Column field="student_name" header="Student Name" style={{ minWidth: '8rem', textAlign: "center" }} />
                        {dates.map((date, index) => (
                            <Column
                                key={index}
                                field={date?.toISOString().split('T')[0]}
                                header={convertToDateWithoutYear(date)}
                                body={dateBody}
                                style={{ maxWidth: '4px', padding: "0" }}
                                className='p1-imp'
                            />
                        ))}
                    </DataTable>
                </div>
            </div>}
        </div>}
        </>
    )
}

export default AttendanceReport
